"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import cafetaria from "../../assets/merchandise-new.jpeg";

export default function BusinessSectionMerchandise() {
  return (
    <BusinessSectionBlock
      title="Start exploring Merchandise"
      description="We pride ourselves on delivering an authentic, rich Islamic spirit across our campus. Students, faculty, and alumni can access our full range of university merchandise."
      image={cafetaria}
      href="/merchandise"
      reverse={false}
    />
  );
}